export const STATE_MODULES = {
	CONFIG: 'config',
	TECHNICIAN: 'technician',
	UTILS: 'utils',
	LOGIN: 'login',
	JOBS: 'jobs',
	LEADS: 'leads',
	QUOTE: 'quote',
	QUIZ: 'quiz'
}
